import Axios from 'axios';
import Env from '@/plugins/protokol/lib/Env'

const http = Axios.create({
  baseURL: Env.get('API_HOST'),
  timeout: 15000,
  responseType: 'json'
});

http.defaults.withCredentials = true

export default http